import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import toastError from "../../errors/toastError";
import api from "../../services/api";

import { AuthContext } from "../../context/Auth/AuthContext";

const VcardPreview = ({ contact, numbers }) => {
  const history = useHistory();
  const { user } = useContext(AuthContext);

  const [selectedContact, setContact] = useState({
    name: "",
    number: 0,
    profilePicUrl: "",
  });

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          let contactObj = {
            name: contact,
            number: numbers !== undefined && numbers.replace(/\D/g, ""),
            email: "",
          };
          const { data } = await api.post("/contact", contactObj);
          setContact(data);
        } catch (err) {
          console.log(err);
          toastError(err);
        }
      };
      fetchContacts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [contact, numbers]);

  const handleNewChat = async () => {
    try {
      const { data: ticket } = await api.post("/tickets", {
        contactId: selectedContact.id,
        userId: user.id,
        status: "open",
      });
      history.push(`/tickets/${ticket.id}`);
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <div className="min-w-[250px] bg-white dark:bg-dark-800 rounded-lg overflow-hidden">
      <div className="flex items-center gap-3 p-3">
        {/* Avatar */}
        {selectedContact.profilePicUrl ? (
          <img
            src={selectedContact.profilePicUrl}
            alt={selectedContact.name}
            className="w-10 h-10 rounded-full object-cover flex-shrink-0"
          />
        ) : (
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary-400 to-primary-600 flex items-center justify-center text-white font-semibold text-sm flex-shrink-0">
            {selectedContact.name?.charAt(0)?.toUpperCase() || "?"}
          </div>
        )}

        {/* Name */}
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-primary-600 dark:text-primary-400 truncate">
            {selectedContact.name}
          </p>
        </div>
      </div>

      {/* Divider and button */}
      <div className="border-t border-dark-200 dark:border-dark-700">
        <button
          onClick={handleNewChat}
          disabled={!selectedContact.number}
          className="w-full py-2 text-sm font-medium text-primary-600 dark:text-primary-400 hover:bg-dark-50 dark:hover:bg-dark-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Conversar
        </button>
      </div>
    </div>
  );
};

export default VcardPreview;
